import { render, staticRenderFns } from "./RoleViewPage.vue?vue&type=template&id=4f018bee&scoped=true&"
import script from "./RoleViewPage.vue?vue&type=script&lang=js&"
export * from "./RoleViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f018bee",
  null
  
)

export default component.exports